module.exports = __webpack_public_path__ + "img/carshare_off.bf065c01.svg";